// Odpověď na komentář
// Přímo u konkrétního komentáře se naklonuje a upraví formulář na vytvoření příspěvku.

import * as Sentry from '@sentry/browser';
import { FlashMessage, SVGLoader } from '@components';
import { prepareFormData } from '@utils/form';
import * as els from './forumElements';
import { forumTextarea } from './forumTextarea';
import * as editTypes from './forumEditCommentTypes';
import { isTextValid } from './forumValidate';
import * as api from './forumApi';

interface ModalEditState {
  commentId: string;
  commentContent: HTMLDivElement;
}

//  TODO: unit testy https://cncenter.atlassian.net/browse/FEG-657
export const forumEditComment = (): void => {
  // UI a data modalu
  let state: ModalEditState;
  const modal = els.modalEdit;

  if (!modal) return;

  const buttonSave: HTMLButtonElement | null = modal.querySelector('[data-save-edit-comment]');
  const textarea: HTMLTextAreaElement | null = modal.querySelector('textarea');
  const { threadId } = modal.dataset;
  const modalBody: HTMLElement | null = modal.querySelector('.modal__body');

  if (!buttonSave || !textarea || !threadId || !modalBody) return;

  // Pro všechny tlačítka 'Editovat'
  els.buttonsEdit.forEach((buttonEdit) => {
    const { editComment: commentId } = buttonEdit.dataset;

    if (!commentId) return;

    // Po kliknutí
    buttonEdit.addEventListener('click', () => {
      // Nastavit hodnoty formuláře
      const commentContentWrapper: HTMLDivElement | null = document.querySelector(
        `[data-comment-id="${commentId.toString()}"]`
      );

      if (!commentContentWrapper) return;
      const commentContent: HTMLDivElement | null = commentContentWrapper.querySelector(
        '.forum__comment-content'
      ) as HTMLDivElement;

      if (!commentContent) return;

      // Změnit stav modalu
      state = {
        commentId,
        commentContent,
      };

      // Nastavit starý komentář pro editaci
      textarea.value = commentContent.textContent ? commentContent.textContent.trim() : '';

      // Sledovat počet chybějících znaků & autoheight
      forumTextarea(textarea);
    });
  });

  // V modálním okně po kliknutí na tlačítko 'Upravit'
  buttonSave.addEventListener('click', () => {
    // Validovat text

    const textValidation = isTextValid({ content: textarea.value, shake: buttonSave });
    if (!textValidation) throw new Error('Text není validní');

    // Schovat UI & přidat loader
    buttonSave.style.display = 'none';
    textarea.style.display = 'none';
    const svgLoader = SVGLoader.create({ addTo: modalBody });

    // Přípravit data
    const { commentId: mid, commentContent } = state;
    const requestData = prepareFormData({
      mid,
      content: textarea.value,
      ajax: '1',
    });

    // Odeslat data
    fetch(api.edit(threadId), {
      method: 'POST',
      body: requestData,
    })
      .then((response) => response.json())
      .then(async (data: editTypes.EditResponseSuccess) => {
        // Informovat uživatele
        await FlashMessage({ msg: 'Komentář byl upraven.', type: 'success' });

        // Aktualizovat data ve staré verzi komentáře
        commentContent.innerHTML = data.status.message;
      })
      .then(() => {
        // Skrýt modal
        modal.style.display = 'none';

        // Reset UI v modalu a odebrat loader
        textarea.style.display = 'block';
        buttonSave.style.display = 'block';
        if (svgLoader) svgLoader.remove();
      })
      .catch(async (err: editTypes.EditResponseError) => {
        Sentry.captureException(err);

        let errorMsg: string;

        switch (err.status) {
          case editTypes.ErrorStatus.NoExist:
            errorMsg = 'Chyba - neexistující příspěvek.';
            break;
          case editTypes.ErrorStatus.NoEdit:
            errorMsg = 'Chyba - nelze editovat cizí příspěvek.';
            break;
          default:
            errorMsg = 'Chyba - někdo už na váš příspěvek reagoval.';
            break;
        }

        // Zdůvodnit neúspěch požadavku
        await FlashMessage({
          msg: errorMsg,
          type: 'error',
        });
      });
  });
};
